<template>
    <div>

        <section class="partner">

            <header class="partner__header">

                <img src="/img/partner/logo-large-white.svg" class="partner__header__img pointer" @click="goLanding">

            </header>

            <div class="partner__body" v-if="isAPartner">

                <div class="partner__body__top">
                    <section class="partner__infos">

                        <div>
                            <img src="/img/partner/picture-cleanfox.png"
                                 class="partner__infos__logo partner__infos__logo__left">
                            <img :src="infos.img" class="partner__infos__logo partner__infos__logo__right">
                        </div>

                        <p class="partner__infos__title">{{ $tc('partner_title', 0, {partner_name: infos.name}) }}</p>

                        <p class="partner__infos__text">{{ $tc('partner_subtitle', 0, {partner_name: infos.name}) }}</p>

                        <div class="partner__infos__cite">
                            <img :src="infos.img" class="partner__infos__cite__img">

                            <markdown class="partner__infos__cite__text" :text="infos.text"></markdown>
                        </div>

                        <links></links>

                    </section>

                    <section class="partner__tips">

                        <div class="partner__tips__item" :class="{'partner__tips__item-we-forest': isWeForest}">
                            <div class="partner__tips__item__top">
                                <p class="partner__tips__item__title">{{ referees }}</p>
                                <p class="partner__tips__item__text">
                                    {{ $tc('nb_registered_partner', referees, {partner_name: infos.name}) }}</p>
                            </div>
                            <div class="partner__tips__item__bottom partner__tips__item__1"></div>
                        </div>

                        <div class="tips-divider" v-show="isWeForest"></div>

                        <div class="partner__tips__item" :class="{'partner__tips__item-we-forest': isWeForest}"
                             v-show="isWeForest">
                            <div class="partner__tips__item__top">
                                <p class="partner__tips__item__title">{{ sqmByPartner }}</p>
                                <p class="partner__tips__item__text">
                                    {{ $t('partner_trees_title') }}</p>
                            </div>
                            <div class="partner__tips__item__bottom partner__tips__item__2"></div>
                        </div>

                        <div class="tips-divider"></div>

                        <div class="partner__tips__item" :class="{'partner__tips__item-we-forest': isWeForest}">
                            <div class="partner__tips__item__top">
                                <p class="partner__tips__item__title">{{ deleted }}</p>
                                <p class="partner__tips__item__text">{{ $tc('statistics_deleted', deleted) }}</p>
                            </div>
                            <div class="partner__tips__item__bottom partner__tips__item__3"></div>
                        </div>

<!--                        <div class="tips-divider"></div>-->

<!--                        <div class="partner__tips__item" :class="{'partner__tips__item-we-forest': isWeForest}">-->
<!--                            <div class="partner__tips__item__top">-->
<!--                                <p class="partner__tips__item__title">{{ computedCo2Text }}</p>-->
<!--                                <p class="partner__tips__item__text">{{ computedCo2Saved }}</p>-->
<!--                            </div>-->
<!--                            <div class="partner__tips__item__bottom partner__tips__item__4"></div>-->
<!--                        </div>-->


                    </section>

                </div>

                <section class="partner__articles">

                    <article class="partner__article">
                        <div class="partner__article__container partner__article__container__works"></div>
                        <h2 class="partner__article__title">{{ $t('How_does_Cleanfox_works') }}</h2>
                        <p class="partner__article__text">{{ $t('partner_how_to') }}</p>
                        <a class="partner__article__cta" :href="`/${lang}/faq.html`">{{ $t('more_title') }}</a>
                    </article>

                    <div class="partner__articles__gap" v-show="isWeForest"></div>

                    <article class="partner__article" v-show="isWeForest">
                        <div class="partner__article__container partner__article__container__weforest">
                            <img src="/img/partner/logo-weforest.webp" class="partner__article__img__weforest">
                        </div>
                        <h2 class="partner__article__title">{{ $t('partner_about_weforest_title') }}</h2>
                        <p class="partner__article__text">{{ $t('partner_about_weforest_description') }}</p>
                        <a class="partner__article__cta" href="https://www.weforest.org/partner/cleanfox"
                           target="_blank" rel="noopener noreferrer nofollow">{{ $t('partner_about_weforest_cta') }}</a>
                    </article>

                </section>


                <section class="partner__faq">

                    <article class="partner__faq__item" v-for="(faq, index) in faqs">
                        <div class="partner__faq__header pointer" @click="toggleFaq(index)">
                            <h2 class="partner__faq__title">{{ $t(faq.title) }}</h2>
                            <img :src="faq.checked ? '/img/partner/arrow-up.svg' : '/img/partner/arrow-down.svg'"
                                 class="partner__faq__arrow">
                        </div>
                        <div class="partner__faq__body" v-show="faq.checked">
                            <p class="partner__faq__text">{{ $t(faq.text) }}</p>
                        </div>
                    </article>

                </section>

            </div>

        </section>

        <footer-fox></footer-fox>

    </div>

</template>

<script>
import Vuex from 'vuex'

import Api from '@/api'

import Storage from '@/helpers/storage'

import I18n from '@/modules/i18n'
import Partners from '@/modules/partners'
import Tag from '@/modules/tag'
import UserAgent from '@/modules/userAgent'
import UserFlow from '@/modules/userFlow'

import FooterFox from '@/components/footer/FooterFox'
import Links from '@/components/partner/links'
import LottieLoader from '@/components/lottie/LottieLoader'
import Markdown from '@/components/Markdown'

export default {

    name: 'partner',

    components: {FooterFox, Links, LottieLoader, Markdown},

    computed: {

        ...Vuex.mapGetters(['lang']),

        isMobile() {
            return UserAgent.is.mobile()
        },

        computedClicked: function () {

            return this.clicked ? this.$t('we_forest_code_copied') : this.$t('partner_cta')

        },

        isAPartner: function () {

            return this.infos && Object.keys(this.infos).length > 0

        },

        playStore() {
            return 'https://play.google.com/store/apps/details?id=io.cleanfox.android&hl=' + this.lang
        },

        computedCo2Text() {
            return this.co2 >= 1000
                ? (this.co2 / 1000).toFixed(2)
                : (this.co2 || 0).toFixed(2)
        },

        computedCo2Saved() {
            return this.co2 >= 1000
                ? this.$tc('partner_carbon_saved_kg', Math.trunc(this.co2 / 1000))
                : this.$tc('partner_carbon_saved_g', Math.trunc(this.co2 || 0))
        },

        isWeForest() {
            return this.infos.type === 'we-forest'
        }

    },

    data() {
        return {
            title: '',
            text: '',
            infos: {},
            clicked: false,
            faqs: [
                // {title: 'partner_digital_pollution', text: 'partner_digital_pollution_2', checked: false},
                // {
                //     title: 'landing_web_questions_subtitle_carbon',
                //     text: 'landing_web_questions_text_carbon',
                //     checked: false
                // },
                {title: 'How_does_Cleanfox_works', text: 'How_does_Cleanfox_works_2', checked: false},
                {title: 'partner_faq_error', text: 'partner_faq_error_2', checked: false}
            ],
            referees: 0,
            sqmByPartner: 0,
            deleted: 0,
            co2: 0,
            appStore: 'https://apps.apple.com/app/id1136298377?mt=8'
        }
    },

    created() {

        this.partnerCode = this.$route.params.name

        Partners.getPartner(this.partnerCode)
            .then(result => {

                this.infos = result

                if (!this.isAPartner) {
                    this.exit()
                }

                UserFlow.setPage(this, `partner_${this.partnerCode}`)

                Api.sponsorship.getByPartner(this.partnerCode)
                    .then(data => {
                        this.referees = data.referees
                        this.sqmByPartner = Math.round(data.sqm)
                        this.deleted = data.deleted
                        this.co2 = data.co2
                    })
                    .catch(() => {
                    })


            })
            .catch(() => {
            })

    },

    methods: {

        exit() {

            if (Storage.getItem('token')) {

                this.$router.push({path: '/newsletters'})
            } else {

                this.$router.push({path: '/'})
            }
        },

        goLanding() {

            this.$router.push({path: '/'})
        },

        clean() {

            Tag.clickAmplitude(this, `partner_${this.$route.params.name}_clean`)

            if (UserAgent.is.mobile()) {
                window.open('https://app.adjust.com/2p936hy', '_blank', 'rel="noopener,noreferrer,nofollow"')
            } else {
                Storage.setItem('partnerCode', this.infos.code)
                this.goLanding()
            }
        },

        toggleFaq(index) {
            this.faqs[index].checked = !this.faqs[index].checked
        },

        goFaq() {
            window.open(`/${I18n.get(this)}/faq.html`)
        }
    }
}
</script>

<style lang="scss" scoped>

.partner {
    background-color: $blue;
    background-image: url('/img/partner/background-mobile.svg');
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;

    @media screen and (min-width: $above-mobile-length) {
        background-image: url('/img/partner/background-desktop.svg');
    }

    &__body {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        @media screen and (min-width: $above-mobile-length) {
            max-width: 772px;
            padding: 80px 16px 80px;
        }
    }

    &__header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px;
        background-color: $white;

        &__img {
            height: 40px;
            object-fit: contain;
        }
    }

    &__infos {
        background-color: $white;
        padding: 32px 20px;
        display: flex;
        flex-direction: column;
        @media screen and (min-width: $above-mobile-length) {
            border-radius: 20px;
            align-items: flex-start;
            text-align: start;
            padding: 64px 32px 32px;
        }

        &__logo {
            width: 96px;
            object-fit: contain;
            border-radius: 120px;
            border: solid 4px $timberwolf;

            &__left {
                margin-right: -10px;
            }

            &__right {
                margin-left: -10px;
            }
        }

        &__title {
            font-size: 40px;
            font-weight: 600;
            line-height: 1.1;
            letter-spacing: -0.4px;
            margin-top: 20px;
            @media screen and (min-width: $above-mobile-length) {
                font-size: 56px;
                font-weight: 600;
                line-height: 1.07;
                letter-spacing: -0.56px;
                margin-top: 40px;
            }
        }

        &__text {
            font-size: 16px;
            line-height: 1.5;
            margin-top: 20px;
            @media screen and (min-width: $above-mobile-length) {
                font-size: 24px;
                line-height: 1.33;
                margin-top: 16px;
            }
        }

        &__cite {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            background-color: $timberwolf;
            border-radius: 20px;
            padding: 16px;
            text-align: start;
            margin-top: 20px;
            @media screen and (min-width: $above-mobile-length) {
                margin-top: 40px;
            }

            &__img {
                width: 40px;
                object-fit: contain;
                margin: 0 16px 0 0;

                &:lang(ar-sa) {
                    margin: 0 0 0 16px;
                }

                border-radius: 72px;
                @media screen and (min-width: $above-mobile-length) {
                    width: 56px;
                }
            }

            &__text {
                font-size: 14px;
                font-weight: 500;
                line-height: 1.43;
            }
        }

        &__link {
            margin-top: 16px;
            font-size: 16px;
            line-height: 1.5;
        }
    }

    &__tips {
        padding: 20px 20px 0;
        margin-top: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;

        @media screen and (min-width: $above-mobile-length) {
            padding: 0;
            flex-direction: row;
            align-items: center;
        }

        &__line {
            display: flex;
            flex-direction: row;
            padding: 0 16px;
            align-items: center;
            justify-content: center;
            @media screen and (min-width: $above-mobile-length) {
                flex-direction: column;
            }
        }

        &__area-free {
            display: flex;
            justify-content: center;

            @media screen and (min-width: $above-mobile-length) {
                justify-content: flex-start;
            }
        }

        &__area {
            display: flex;
            align-items: center;
            @media screen and (min-width: $above-mobile-length) {
                margin: 0 0 20px 0;
            }
        }


        &__item {
            width: 100%;
            min-height: 335px;
            background-color: $white;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 16px;
            margin-top: 24px;
            max-width: 356px;
            overflow: hidden;
            @media screen and (min-width: $above-mobile-length) {
                margin-top: 0px;
                min-height: 222px;
            }

            &__top {
                padding: 30px;
                @media screen and (min-width: $above-mobile-length) {
                    padding: 20px;
                }
            }

            &__bottom {
                background-repeat: no-repeat;
                background-position: bottom;
                background-size: contain;
                min-height: 200px;
                width: 100%;
                display: flex;
                flex: 1;
                @media screen and (min-width: $above-mobile-length) {
                    min-height: auto;
                }
            }

            &__1 {
                background-image: url('/img/partner/illustration-account-created.svg');
            }

            &__2 {
                background-image: url('/img/partner/illustration-tree-planted.svg');
            }

            &__3 {
                background-image: url('/img/partner/illustration-mail-deleted.svg');
            }

            &__4 {
                background-image: url('/img/partner/illustration-co-2-saved.svg');
            }

            &__title {
                font-size: 42.3px;
                font-weight: 600;
                line-height: 1.14;
                @media screen and (min-width: $above-mobile-length) {
                    font-size: 28px;
                    font-weight: 600;
                    line-height: 1.14;
                }
            }

            &__text {
                margin-top: 3px;
                font-size: 21.1px;
                font-weight: 500;
                line-height: 1.14;
                color: $moon;
                @media screen and (min-width: $above-mobile-length) {
                    margin-top: 2px;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 1.14;
                }
            }
        }

        &__item-we-forest {
            @media screen and (min-width: $above-mobile-length) {
                min-height: 180px;
            }
        }
    }

    &__articles {
        padding: 20px;
        @media screen and (min-width: $above-mobile-length) {
            display: flex;
            flex-direction: row;
            padding: 0;
        }

        &__gap {
            @media screen and (min-width: $above-mobile-length) {
                width: 20px;
            }
        }
    }

    &__article {
        margin-top: 20px;
        padding: 24px;
        display: flex;
        flex-direction: column;
        border-radius: 20px;
        background-color: $white;
        align-items: flex-start;
        text-align: start;
        @media screen and (min-width: $above-mobile-length) {
            flex: 1;
            margin-top: 40px;
        }

        &__container {
            width: 100%;
            border-radius: 8px;
            background-color: $mint;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            height: 200px;

            &__works {
                background-image: url('/img/partner/mailbox-mobile.svg');
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;
                @media screen and (min-width: $above-mobile-length) {
                    background-image: url('/img/partner/mailbox-desktop.svg');
                }
            }

            &__weforest {
                align-items: center;
                background-color: $rifle;
            }
        }

        &__img {
            width: 128px;
            object-fit: contain;

            &__weforest {
                width: 220px;
                object-fit: contain;
            }
        }

        &__title {
            margin-top: 32px;
            font-size: 20px;
            font-weight: 600;
            line-height: 1.2;
            letter-spacing: -0.2px;
        }

        &__text {
            margin-top: 8px;
            font-size: 16px;
            line-height: 1.5;
            flex-grow: 1;
        }

        &__cta {
            margin-top: 32px;
            padding: 10px 20px;
            background-color: $mint;
            border-radius: 72px;
            font-size: 16px;
            font-weight: 600;
            line-height: 1.25;
            color: $rifle;
        }
    }

    &__faq {
        padding: 20px 20px 40px;
        width: 100%;

        @media screen and (min-width: $above-mobile-length) {
            padding: 40px 0 40px;
        }

        &__item {
            margin-top: 8px;
            padding: 20px;
            display: flex;
            flex-direction: column;
            background-color: $white;
            border-radius: 12px;
        }

        &__header {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            text-align: start;
        }

        &__title {
            font-size: 16px;
            font-weight: 600;
            line-height: 1.5;
            margin-right: 12px;
            @media screen and (min-width: $above-mobile-length) {
                font-size: 20px;
                font-weight: 600;
                line-height: 1.2;
            }
        }

        &__arrow {
            width: 20px;
            object-fit: contain;
        }

        &__body {
            margin-top: 20px;
        }

        &__text {
            font-size: 14px;
            line-height: 1.43;
            text-align: start;
            @media screen and (min-width: $above-mobile-length) {
                font-size: 16px;
                line-height: 1.5;
            }
        }
    }

    .link {
        margin-top: 16px;
        font-size: 16px;
        line-height: 1.5;
        color: $charcoal;
        text-decoration: none;
    }

    .tips-divider {
        @media screen and (min-width: $above-mobile-length) {
            width: 17px;
        }
    }
}

</style>
